import { motion } from "framer-motion";
import { BloodDrip } from "@/components/BloodDrip";

const CHAPTERS = [
  {
    number: "I",
    title: "THE BLOODLINE",
    content:
      "Atrocity Comix was born in 2018 from a raw, unfiltered hunger for stories that cut through the noise. A small collective of writers, artists, and renegade thinkers who saw the darkness in the world — and refused to look away.",
  },
  {
    number: "II",
    title: "THE FEMMES",
    content:
      "Our pages belong to her — the vengeful, the wicked, the unrepentant. Horror tales where the femme fatale is never the victim. She is the warning, the weapon, and the last page.",
  },
  {
    number: "III",
    title: "THE UNHOLY PRESS",
    content:
      "What began as a scrappy zine has grown into a fearless independent press. Our creed is unchanged: authenticity over comfort, a disdain for censorship, and the belief that ink can still raise the dead.",
  },
];

export default function Manifesto() {
  return (
    <section id="story" className="relative py-28 sm:py-36 newsprint-grain">
      <div className="absolute inset-0 blood-vignette pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="font-marker text-paper text-base sm:text-lg mb-3 -rotate-1 inline-block"
        >
          three chapters, written in blood
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase text-paper mb-16 sm:mb-24"
        >
          THE <span className="text-crimson">MANIFESTO</span>
          <BloodDrip />
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-8 sm:gap-10">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.number}
              data-testid={`manifesto-chapter-${i + 1}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.2 }}
              className="group relative border border-blooddeep/50 bg-pulp p-8 transition-colors duration-300 hover:border-crimson"
            >
              <div className="absolute inset-0 halftone opacity-0 group-hover:opacity-10 transition-opacity duration-300 pointer-events-none" />
              <span className="font-display text-6xl sm:text-7xl text-crimson block mb-6">
                {c.number}
              </span>
              <h3 className="font-impact uppercase tracking-widest text-xl sm:text-2xl text-paper mb-4">
                {c.title}
              </h3>
              <div className="w-10 h-px bg-crimson mb-4" />
              <p className="font-type text-sm text-paper/65 leading-relaxed">{c.content}</p>
            </motion.article>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="font-marker text-bloodglow text-xl sm:text-2xl text-center mt-20 rotate-[-1deg]"
        >
          "We don't publish stories. We unleash them."
        </motion.p>
      </div>
    </section>
  );
}
